"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicService = void 0;
class DynamicService {
    subject;
    client;
    constructor(subject, client) {
        this.subject = subject;
        this.client = client;
    }
    static capitalize(input) {
        const letters = input.split('');
        const first = letters[0].toUpperCase();
        const otherLetters = letters.filter((_, index) => index).join('');
        return first + otherLetters;
    }
    generateSubscribeMethod = (target, event) => {
        return (id, subscriber) => {
            return this.subject.subscribe(event, { ...target, id }, subscriber);
        };
    };
    generateUnsubscribeFromCaseAndEventMethod = (target, event) => {
        return () => {
            this.subject.unsubscribeFromCaseAndEvent(event, target);
        };
    };
    generateUnsubscribeFromCaseMethod = (target) => {
        return () => {
            this.subject.unsubscribeFromCase(target);
        };
    };
    generateTriggerMethod = (target, event) => {
        return (id, payload) => {
            this.client.notify(event, { ...target, id }, payload);
        };
    };
    generateModule(strategy) {
        const module = {};
        Object.keys(strategy).forEach((caseName) => {
            module[caseName] = {};
            const caseTarget = strategy[caseName].target;
            const eventsMap = strategy[caseName].events;
            Object.keys(eventsMap).forEach((event) => {
                const capitalizedEventName = DynamicService.capitalize(event);
                const subscribeMethodName = `subscribeOn${capitalizedEventName}Event`;
                const subscribeMethod = this.generateSubscribeMethod(caseTarget, event);
                module[caseName][subscribeMethodName] = subscribeMethod.bind(this);
                const unsubscribeFromCaseAndEventMethodName = `unsubscribeFromAll${capitalizedEventName}EventRooms`;
                const unsubscribeFromCaseAndEventMethod = this.generateUnsubscribeFromCaseAndEventMethod(caseTarget, event);
                module[caseName][unsubscribeFromCaseAndEventMethodName] = unsubscribeFromCaseAndEventMethod.bind(this);
                const triggerMethodName = `trigger${capitalizedEventName}Event`;
                const triggerMethod = this.generateTriggerMethod(caseTarget, event);
                module[caseName][triggerMethodName] = triggerMethod.bind(this);
            });
            const unsubscribeFromCaseMethod = this.generateUnsubscribeFromCaseMethod(caseTarget);
            module[caseName]['unsubscribeFromAllEvents'] = unsubscribeFromCaseMethod.bind(this);
        });
        return module;
    }
}
exports.DynamicService = DynamicService;
